import React from 'react';
import { Alert, AlertDescription } from '@roger/ui-components';
import { Loader2, Info } from 'lucide-react';
import QA2VisitCard from './QAVisitCard';
import { QAVisit } from '@/types/visitData.types';

interface QAVisitsListProps {
  searchResults: QAVisit[];
  searching: boolean;
  hasSearched: boolean;
  onVisitClick: (visit: QAVisit) => void;
}

const QAVisitsList: React.FC<QAVisitsListProps> = ({
  searchResults,
  searching,
  hasSearched,
  onVisitClick,
}) => {
  // Loading state
  if (searching) {
    return (
      <div className='flex justify-center items-center py-12'>
        <div className='flex items-center gap-3 text-gray-700'>
          <Loader2 className='h-5 w-5 animate-spin text-blue-600' />
          <span className='text-sm'>Loading visits...</span>
        </div>
      </div>
    );
  }

  // Results found
  if (searchResults.length > 0) {
    return (
      <>
        <span className='font-semibold'>
          {searchResults.length} Visit(s) Found
        </span>

        <div className='space-y-3 mt-4'>
          {searchResults.map(visit => (
            <QA2VisitCard
              key={visit.visit_id}
              visit={visit}
              onClick={onVisitClick}
            />
          ))}
        </div>
      </>
    );
  }

  // No results
  if (searchResults.length === 0 && hasSearched && !searching) {
    return (
      <Alert className='border-blue-200 bg-blue-50'>
        <AlertDescription className='text-blue-800 flex items-center gap-2'>
          <Info className='h-4 w-4 text-blue-600' />
          No visits are available for QA review with the current filters. Please
          try adjusting your search filters or expanding your date range.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};

export default QAVisitsList;
